import { SVGProps } from 'react';
import * as React from 'react';

/** Icona ordinamento: freccia + linee (stile controllo “ordina per”). */
const SvgIcSort = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 6c.6 0 1 .4 1 1v8.2l1.6-1.6 1.4 1.4-4 4-4-4 1.4-1.4L7 15.2V7c0-.6.4-1 1-1z"
    />
    <path
      fill="currentColor"
      d="M14 7h12v2H14V7zm0 6h8v2H14v-2zm0 6h5v2h-5v-2z"
    />
  </svg>
);

export default SvgIcSort;
